module.exports = __webpack_public_path__ + "static/CP86-Overview-15316a84c875d7afada93c46bfc6342c.pdf";